import { FunctionComponent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { TCHOP_ROOT_URL } from '../../../../env';
import { organisationApi } from '../../../../services';
import { Button, ButtonType, Check } from '../../../../shared';

import classes from './Danger.module.scss';

export const Danger: FunctionComponent = () => {
  const { t } = useTranslation();

  const { t: ctxT } = useTranslation('', { keyPrefix: 'orgDashboardDanger' });

  const [organisationDelete] = organisationApi.endpoints.organisationDelete.useMutation();

  const [loading, setLoading] = useState(false);

  const [checked, setChecked] = useState<boolean>(false);

  const organisationDeleteHandler = useCallback(async () => {
    setLoading(true);

    try {
      const payload = await toast.promise(organisationDelete().unwrap(), {
        pending: ctxT('pending'),
        success: ctxT('success'),
      });

      if (!payload) {
        return;
      }

      if (TCHOP_ROOT_URL.endsWith('tchop.it')) {
        window.location.replace('https://tchop.it/me');
        return;
      }

      window.location.replace('https://tchop.io/me');
    } catch (_) {
      toast.error(ctxT('error'));
    } finally {
      setLoading(false);
    }
  }, [ctxT, organisationDelete]);

  return (
    <div className={classes['danger']}>
      <div className={classes['danger__message']}>{ctxT('message')}</div>
      <div>
        <Check
          className={classes['danger__check']}
          checked={checked}
          onChange={setChecked}
          label={t('common.i-understand')}
        />
      </div>
      <Button
        className={classes['danger__button']}
        label={ctxT('delete')}
        type={ButtonType.primary}
        disabled={!checked || loading}
        onClick={organisationDeleteHandler}
        loading={loading}
        danger
      />
    </div>
  );
};
